import { Video } from "../types";
import ResourceService from "../common/Services/ResourceService";

class VideoService extends ResourceService<Video> {
  constructor() {
    super({
      path: "/videos",
      queryKey: "videos",
    });
  }

  static listVideos() {
    return new VideoService().list();
  }

  static fetchVideo(id: Video["id"]) {
    return new VideoService().fetch({ id });
  }

  static createVideo(payload?: Partial<Video>) {
    return new VideoService().create(payload);
  }

  static updateVideo(id: Video["id"], payload: Partial<Video>) {
    return new VideoService().update({ ...payload, id });
  }

  static deleteVideo(id: Video["id"]) {
    return new VideoService().deleteOne({ id });
  }
}

export default VideoService;
